import React from "react";
import { Col, Row, Card } from "antd";
import "antd/dist/antd.css";

import { PieChart, Pie, ResponsiveContainer } from "recharts";

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  name
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text
      style={{ fontSize: "x-large" }}
      transform={`translate(${x},${y}) rotate(90)`}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {name}
    </text>
  );
};

function TaChart(props) {
  const numberCells_1 = [
    { name: props.language === "en" ? "A" : "A", value: 300 }
  ];
  const numberCells_2 = [
    {
      name: props.language === "en" ? "NP" : "NP",
      value: 300
    },
    {
      name: props.language === "en" ? "CP" : "CP",
      value: 300
    }
  ];
  const numberCells_3 = [
    { name: props.language === "en" ? "AC" : "AC", value: 300 },
    {
      name: props.language === "en" ? "WC" : "WC",
      value: 300
    },
    {
      name: props.language === "en" ? "NC" : "NC",
      value: 300
    }
  ];
  const defaultWidth = 96;
  const thirdPieData = [
    {
      title: props.data[4].key,
      value: 300,
      own: props.data[4].own * 3,
      peerAverage: props.data[4].peerAverage * 3
    },
    {
      title: props.data[5].key,
      own: props.data[5].own * 3,
      peerAverage: props.data[5].peerAverage * 3
    },
    {
      title: props.data[3].key,
      own: props.data[3].own * 3,
      peerAverage: props.data[3].peerAverage * 3
    }
  ];

  const secondPieData = [
    {
      title: props.data[1].key,
      value: 300,
      own: props.data[1].own * 3,
      peerAverage: props.data[1].peerAverage * 3
    },
    {
      title: props.data[0].key,
      own: props.data[0].own * 3,
      peerAverage: props.data[0].peerAverage * 3
    }
  ];

  const firstPieData = [
    {
      title: props.data[2].key,
      value: 300,
      own: props.data[2].own * 3,
      peerAverage: props.data[2].peerAverage * 3
    }
  ];

  function renderSwitch(numberCells) {
    switch (numberCells) {
      case 1:
        return [
          <div style={{ display: "inline-block" }}>
            <Row type="flex">
              {" "}
              <Card
                style={{ width: defaultWidth, fontSize: "x-large" }}
                title={props.language === "en" ? "Own" : "Egen"}
                bordered={false}
              >
                <p style={{ color: "#000" }}>{firstPieData[0].own}</p>
              </Card>
              {firstPieData[0].peerAverage ? (
                <Card
                  style={{ width: defaultWidth, fontSize: "x-large" }}
                  className="othersColumn"
                  title={props.language === "en" ? "Others" : "Andres"}
                  bordered={false}
                >
                  <p style={{ color: "#000" }}>{firstPieData[0].peerAverage}</p>
                </Card>
              ) : null}
            </Row>{" "}
          </div>
        ];

      case 2:
        return [
          <div style={{ float: "right" }}>
            <Row type="flex">
              <Col>
                <Card
                  style={{ fontSize: "x-large" }}
                  title={props.language === "en" ? "Own" : "Egen"}
                  bordered={false}
                >
                  <p style={{ color: "#000" }}>{secondPieData[0].own}</p>
                </Card>

                {secondPieData[0].peerAverage ? (
                  <Card
                    style={{ fontSize: "x-large" }}
                    className="othersColumn"
                    title={props.language === "en" ? "Others" : "Andres"}
                    bordered={false}
                  >
                    <p style={{ color: "#000" }}>
                      {secondPieData[0].peerAverage}
                    </p>
                  </Card>
                ) : null}
              </Col>
            </Row>
          </div>,

          <div style={{ float: "left" }}>
            <Row type="flex">
              <Col>
                <Card
                  style={{ fontSize: "x-large" }}
                  title={props.language === "en" ? "Own" : "Egen"}
                  bordered={false}
                >
                  <p style={{ color: "#000" }}>{secondPieData[1].own}</p>
                </Card>

                {secondPieData[1].peerAverage ? (
                  <Card
                    style={{ fontSize: "x-large" }}
                    className="othersColumn"
                    title={props.language === "en" ? "Others" : "Andres"}
                    bordered={false}
                  >
                    <p style={{ color: "#000" }}>
                      {secondPieData[1].peerAverage}
                    </p>
                  </Card>
                ) : null}
              </Col>
            </Row>
          </div>
        ];

      case 3:
        return [
          <div style={{ display: "inline-block" }}>
            <Row type="flex">
              <Col>
                {" "}
                <Card
                  style={{ width: defaultWidth, fontSize: "x-large" }}
                  title={props.language === "en" ? "Own" : "Egen"}
                  bordered={false}
                >
                  <p
                    style={{
                      color: "#000"
                    }}
                  >
                    {thirdPieData[0].own}
                  </p>
                </Card>
              </Col>{" "}
              {thirdPieData[0].peerAverage ? (
                <Col>
                  <Card
                    style={{ width: defaultWidth, fontSize: "x-large" }}
                    className="othersColumn"
                    title={props.language === "en" ? "Others" : "Andres"}
                    bordered={false}
                  >
                    <p style={{ color: "#000" }}>
                      {thirdPieData[0].peerAverage}
                    </p>
                  </Card>
                </Col>
              ) : null}
            </Row>{" "}
          </div>,
          <div style={{ float: "right" }}>
            <Row type="flex">
              <Col>
                {" "}
                <Card
                  style={{ fontSize: "x-large" }}
                  title={props.language === "en" ? "Own" : "Egen"}
                  bordered={false}
                >
                  <p style={{ color: "#000" }}>{thirdPieData[1].own}</p>
                </Card>
                {thirdPieData[1].peerAverage ? (
                  <Card
                    style={{ fontSize: "x-large" }}
                    title={props.language === "en" ? "Others" : "Andres"}
                    className="othersColumn"
                    bordered={false}
                  >
                    <p style={{ color: "#000" }}>
                      {thirdPieData[1].peerAverage}
                    </p>
                  </Card>
                ) : null}
              </Col>
            </Row>{" "}
          </div>,

          <div style={{ float: "left" }}>
            <Row type="flex">
              <Col>
                {" "}
                <Card
                  title={props.language === "en" ? "Own" : "Egen"}
                  style={{ fontSize: "x-large" }}
                  bordered={false}
                >
                  <p style={{ color: "#000" }}>{thirdPieData[2].own}</p>
                </Card>
                {thirdPieData[2].peerAverage ? (
                  <Card
                    title={props.language === "en" ? "Others" : "Andres"}
                    className="othersColumn"
                    bordered={false}
                    style={{ fontSize: "x-large" }}
                  >
                    <p style={{ color: "#000" }}>
                      {thirdPieData[2].peerAverage}
                    </p>
                  </Card>
                ) : null}
              </Col>
            </Row>{" "}
          </div>
        ];

      default:
      // code block
    }
  }
  const data =
    props.numberCells === 1
      ? numberCells_1
      : props.numberCells === 2
      ? numberCells_2
      : numberCells_3;

  return (
    <ResponsiveContainer>
      <Row gutter={16}>
        <Col span={8}>
          {" "}
          <div>
            {renderSwitch(props.numberCells).length === 2
              ? renderSwitch(props.numberCells)[0]
              : renderSwitch(props.numberCells)[1]}
          </div>
        </Col>

        <Col span={8}>
          {" "}
          <div style={{ width: "100%", height: 310 }} className="rotate">
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  isAnimationActive={false}
                  data={data}
                  labelLine={false}
                  label={renderCustomizedLabel}
                  fill="#0eb89a"
                  dataKey="value"
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div>
            {renderSwitch(props.numberCells).length === 2
              ? null
              : renderSwitch(props.numberCells)[0]}
          </div>
        </Col>

        <Col span={8}>
          <div>
            {renderSwitch(props.numberCells).length === 2
              ? renderSwitch(props.numberCells)[1]
              : renderSwitch(props.numberCells)[2]}
          </div>
        </Col>
      </Row>
    </ResponsiveContainer>
  );
}

export default TaChart;



// WEBPACK FOOTER //
// ./src/components/Charts/PieChart/PieChart.js